// Pure geometry + pairing helpers for the drag-to-place comparison steps (Q1 scale, Q2 box).
// Kept out of the components so the "drop on less auto-selects more" rule and the point-in-rect
// hit test are unit-testable without a DOM / pointer-gesture harness.

// Is the pointer (a framer `info.point`, in viewport coords) inside a slot/box rect
// (a getBoundingClientRect result)? Tolerant of a null rect (ref not yet attached).
export const pointInRect = (point, rect) => (
  !!rect
  && point.x >= rect.left && point.x <= rect.right
  && point.y >= rect.top && point.y <= rect.bottom
);

// Which generality slot, if any, the drag ended over. Top wins ties (they never overlap anyway).
export const slotForPoint = (point, topRect, bottomRect) => {
  if (pointInRect(point, topRect)) return "top";
  if (pointInRect(point, bottomRect)) return "bottom";
  return null;
};

// The top-placed ("more probable" / "more necessary") card id after dropping `droppedId` onto
// `slot`. The scale is a strict either/or, so dropping a card on "less" auto-selects the *other*
// card as "more". Returns null when the drop missed both slots (caller springs the card back).
export const topIdForDrop = (droppedId, slot, cardAId, cardBId) => {
  if (slot === "top") return droppedId;
  if (slot === "bottom") return droppedId === cardAId ? cardBId : cardAId;
  return null;
};
